
export default e => {
    console.log('[Force reload listener] Signal received', e)
    window.location.reload();
}
